import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSgpModel } from "../sgpModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ISgpDetail } from "../sgpTypes";
import { formatNum } from "@/utils/utils";
import moment from 'moment';


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useSgpModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISgpDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'realCode',
            fixed: "left",
        }, {
            title: '客户名称',
            width: 100,
            dataIndex: 'customerName',
            ellipsis: true,
        }, {
            title: '贸易国别',
            width: 160,
            dataIndex: 'countryCode',
            render: text => getTreeNodeName(text),
            ellipsis: true,
        }, {
            title: '币种',
            width: 160,
            dataIndex: 'currencyCode',
            render: text => getTreeNodeName(text),
        }, {
            title: '外贸合同金额',
            width: 160,
            dataIndex: 'contractAmount',
            render: (t, r) => `${r.currency}${t}`,
        }, {
            title: '折算汇率',
            width: 160,
            dataIndex: 'exchangeRate',
            ellipsis: true,
        }, {
            title: '外贸合同金额(RMB)',
            width: 180,
            dataIndex: "gtmAmount",
            render: (t, r) => `￥${t}`,
        }, {
            title: '采购合同总金额',
            width: 200,
            dataIndex: "purchaseAmount",
            render: (t, r) => `￥${t}`,
        }, {
            title: '费用',
            width: 100,
            dataIndex: 'oceanFreight',
            render: (t, r) => `${r.currency}${t}`,
        }, {
            title: '合同毛利润',
            width: 100,
            dataIndex: 'grossProfit',
            render: (t, r) => `${r.currency}${t}`,
        }, {
            title: '合同毛利率',
            width: 100,
            dataIndex: 'grossProfitMargin',
        }, {
            title: '签约时间',
            width: 100,
            dataIndex: 'createTime',
            render: t => moment(t).format("YYYY-MM-DD"),
            ellipsis: true,
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
